document.addEventListener('DOMContentLoaded', function () {
  const els = {
    cards: document.querySelectorAll('.bab-card'),
    flavorModal: document.getElementById('babFlavorModal'),
    modalMainImg: document.getElementById('babModalMainImg'),
    modalThumb1: document.getElementById('babModalThumb1'),
    modalThumb2: document.getElementById('babModalThumb2'),
    modalThumbBtns: document.querySelectorAll('.bab-modal__thumb'),
    modalTitle: document.getElementById('babModalTitle'),
    modalDesc: document.getElementById('babModalDesc'),
    modalIngredients: document.getElementById('babModalIngredients'),
    modalAllergens: document.getElementById('babModalAllergens'),
    modalNutritionLabel: document.getElementById('babModalNFacts')
  };

  function openModal(modal) {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('overflow-hidden');
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.style.display = '';
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden');
  }

  function closeAllModals() {
    document.querySelectorAll('.bab-modal').forEach(modal => {
      modal.classList.remove('is-open');
      modal.style.display = '';
      modal.setAttribute('aria-hidden', 'true');
    });

    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden');
  }

  function bindAccordion(productId) {
    const buttons = document.querySelectorAll('#babFlavorModal .bab-accordion__btn');
    const contents = document.querySelectorAll('#babFlavorModal .bab-accordion__content');

    buttons.forEach((btn) => {
      btn.onclick = function () {
        const content = btn.nextElementSibling;

        if (btn.classList.contains('active')) {
          btn.classList.remove('active');
          content.classList.remove('open');
          return;
        }

        buttons.forEach(b => b.classList.remove('active'));
        contents.forEach(c => c.classList.remove('open'));

        btn.classList.add('active');
        content.classList.add('open');

        if (content.id === 'babModalNFacts') {
          loadNutritionFacts(productId);
        }
      };
    });
  }

  function loadNutritionFacts(productId) {
    if (!els.modalNutritionLabel) return;

    const hiddenWrap = document.getElementById(`babHiddenNutrition-${productId}`);
    els.modalNutritionLabel.innerHTML = '';

    if (!hiddenWrap) {
      els.modalNutritionLabel.innerHTML = '<p style="color:#999;">No nutrition data available.</p>';
      return;
    }

    const renderedLabel =
      hiddenWrap.querySelector('.nutrition-label') ||
      hiddenWrap.querySelector('[class*="nutrition"]') ||
      hiddenWrap.firstElementChild;

    if (renderedLabel) {
      els.modalNutritionLabel.appendChild(renderedLabel.cloneNode(true));
    } else {
      els.modalNutritionLabel.innerHTML = '<p style="color:#999;">Nutrition label is still loading.</p>';
    }
  }

  function resetAccordion() {
    document.querySelectorAll('#babFlavorModal .bab-accordion__btn').forEach(btn => {
      btn.classList.remove('active');
    });

    document.querySelectorAll('#babFlavorModal .bab-accordion__content').forEach(content => {
      content.classList.remove('open');
    });

    if (els.modalNutritionLabel) {
      els.modalNutritionLabel.innerHTML = '';
    }
  }

  function openFlavorModal(productId) {
    const card = document.querySelector(`.bab-card[data-id="${productId}"]`);
    if (!card) return;

    const dataEl = card.querySelector('.bab-card__data');
    if (!dataEl) return;

    let productData;
    try {
      productData = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.error('Invalid product JSON', error);
      return;
    }

    const image1 = productData.image1 || '';
    const image2 = productData.image2 || image1;

    if (els.modalMainImg) {
      els.modalMainImg.src = image1;
      els.modalMainImg.alt = `${productData.title || 'Product'} image 1`;
    }

    if (els.modalThumb1) {
      els.modalThumb1.src = image1;
      els.modalThumb1.alt = `${productData.title || 'Product'} thumbnail 1`;
    }

    if (els.modalThumb2) {
      els.modalThumb2.src = image2;
      els.modalThumb2.alt = `${productData.title || 'Product'} thumbnail 2`;
    }

    els.modalThumbBtns.forEach(btn => {
      btn.classList.remove('is-active');

      if (btn.dataset.thumb === '1') {
        btn.classList.add('is-active');
      }

      btn.onclick = function () {
        const thumbImg = btn.querySelector('img');
        if (!thumbImg || !els.modalMainImg) return;

        els.modalMainImg.src = thumbImg.src;
        els.modalMainImg.alt = thumbImg.alt;

        els.modalThumbBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      };
    });

    if (els.modalTitle) els.modalTitle.textContent = productData.title || '';
    if (els.modalDesc) {
      els.modalDesc.textContent = productData.description || 'Delicious handcrafted cookie baked fresh daily.';
    }
    if (els.modalIngredients) els.modalIngredients.textContent = productData.ingredients || '';
    if (els.modalAllergens) els.modalAllergens.textContent = productData.allergens || '';

    resetAccordion();
    bindAccordion(productId);
    openModal(els.flavorModal);
  }

  els.cards.forEach(card => {
    const quickViewBtn = card.querySelector('.bab-card__quickview-btn');
    const productId = card.dataset.id;

    if (quickViewBtn) {
      quickViewBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openFlavorModal(productId);
      });
    }
  });

  document.querySelectorAll('.bab-modal').forEach(modal => {
    const overlay = modal.querySelector('.bab-modal__overlay');
    const closeBtn = modal.querySelector('.bab-modal__close');

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeModal(modal);
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeModal(modal);
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllModals();
    }
  });
});